/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import Link from "next/link";
import * as Text from "@/components/text";
import { es } from "date-fns/locale";

const mexicanStates = [
  { id: 0, name: "Aguascalientes", short: "Ags" },
  { id: 1, name: "Baja California", short: "BC" },
  { id: 2, name: "Baja California Sur", short: "BCS" },
  { id: 3, name: "Campeche", short: "Camp" },
  { id: 4, name: "Chiapas", short: "Chia" },
  { id: 5, name: "Chihuahua", short: "Chih" },
  { id: 6, name: "Ciudad de México", short: "CDMX" },
  { id: 7, name: "Coahuila", short: "Coah" },
  { id: 8, name: "Colima", short: "Col" },
  { id: 9, name: "Durango", short: "Dgo" },
  { id: 10, name: "Estado de México", short: "EdoMex" },
  { id: 11, name: "Guanajuato", short: "Gto" },
  { id: 12, name: "Guerrero", short: "Gro" },
  { id: 13, name: "Hidalgo", short: "Hgo" },
  { id: 14, name: "Jalisco", short: "Jal" },
  { id: 15, name: "Michoacán", short: "Mich" },
  { id: 16, name: "Morelos", short: "Mor" },
  { id: 17, name: "Nayarit", short: "Nay" },
  { id: 18, name: "Nuevo León", short: "NL" },
  { id: 19, name: "Oaxaca", short: "Oax" },
  { id: 20, name: "Puebla", short: "Pue" },
  { id: 21, name: "Querétaro", short: "Qro" },
  { id: 22, name: "Quintana Roo", short: "QR" },
  { id: 23, name: "San Luis Potosí", short: "SLP" },
  { id: 24, name: "Sinaloa", short: "Sin" },
  { id: 25, name: "Sonora", short: "Son" },
  { id: 26, name: "Tabasco", short: "Tab" },
  { id: 27, name: "Tamaulipas", short: "Tamps" },
  { id: 28, name: "Tlaxcala", short: "Tlax" },
  { id: 29, name: "Veracruz", short: "Ver" },
  { id: 30, name: "Yucatán", short: "Yuc" },
  { id: 31, name: "Zacatecas", short: "Zac" },
];

export default function EventCard({
  size = "md",
  event_url = "",
  event_type = "",
  date_time = "",
  event_extra_detail = "",
  event_title = "",
  event_venue = "",
  event_state = "",
  event_image_url = "https://images.unsplash.com/photo-1658686873732-c93680078088?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
}) {
  const dateFormatted =
    typeof date_time === "object"
      ? "Del " +
      format(new Date(date_time?.from), "EEE d LLLL | HH:mm", {
        locale: es,
      }) +
      " al " +
      format(new Date(date_time?.to), "EEE d LLLL | HH:mm", { locale: es })
      : format(new Date(date_time), "EEE d LLLL | HH:mm", { locale: es });

  const [overlay_vissible, toggle_overlay_vissible] = useState(false);
  return (
    <div>
      <Link href={event_url === null ? "" : event_url} passHref>
        {size === "lg" && (
          <div className="group  max-w-lg">
            <div className="space-y-4">
              <Text.Overline
                size="lg"
                className="text-solid-900 bg-neutral-100 p-1"
              >
                {event_type}
              </Text.Overline>
              <div className="relative ">
                <img
                  src={event_image_url}
                  className="aspect-[2/3] max-h-[184px] w-full object-cover"
                  alt=""
                />
                <div className="absolute top-0 h-full w-full from-black/50  transition duration-300 group-hover:bg-gradient-to-t group-hover:ease-in-out"></div>
              </div>
            </div>

            <div className="p-1">
              <div>
                <Text.Title
                  as="p"
                  size="lg"
                  className="line-clamp-2 text-ellipsis font-bold"
                >
                  {event_title}
                </Text.Title>
                <Text.Title as="p" fontWeight="bold" size="xl">
                  {!overlay_vissible ? dateFormatted : dateFormatted} hrs
                </Text.Title>
                <Text.Body as="p" size="xl" className="text-neutral-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="inline-block h-6 w-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                    />
                  </svg>
                  <span>
                    &nbsp;
                    {mexicanStates.find(
                      (e) =>
                        e.name.localeCompare(event_state, "es", {
                          sensitivity: "base",
                        }) === 0
                    )?.short || event_venue}
                  </span>
                </Text.Body>
              </div>
            </div>
          </div>
        )}
        {size === "md" && (
          <div className="group  max-w-lg">
            <div className="space-y-4">
              <Text.Overline
                size="lg"
                className="text-solid-900 bg-neutral-100 p-1"
              >
                {event_type}
              </Text.Overline>
              <div className="relative ">
                <img
                  src={event_image_url}
                  className="aspect-[2/3] max-h-[160px] w-full object-cover"
                  alt=""
                />
                <div className="absolute top-0 h-full w-full from-black/50  transition duration-300 group-hover:bg-gradient-to-t group-hover:ease-in-out"></div>
              </div>
            </div>

            <div className="p-1">
              <div>
                <Text.Body
                  as="p"
                  size="xl"
                  className="line-clamp-2 text-ellipsis font-bold"
                >
                  {event_title}
                </Text.Body>
                <Text.Body as="p" className="font-semibold" size="xl">
                  {!overlay_vissible ? dateFormatted : dateFormatted} hrs
                </Text.Body>
                <Text.Body as="p" size="lg" className="text-neutral-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="inline-block h-5 w-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                    />
                  </svg>
                  <span>
                    {mexicanStates.find(
                      (e) =>
                        e.name.localeCompare(event_state, "es", {
                          sensitivity: "base",
                        }) === 0
                    )?.short || event_venue}
                  </span>
                </Text.Body>
              </div>
            </div>
          </div>
        )}
      </Link>
    </div>
  );
}

EventCard.propTypes = {
  event_title: PropTypes.string.isRequired,
  event_url: PropTypes.string.isRequired,
  event_type: PropTypes.string,
  date_time: PropTypes.instanceOf(Date) || PropTypes.string || PropTypes.object,
  event_extra_detail: PropTypes.string,
  event_venue: PropTypes.string.isRequired,
  event_image_url: PropTypes.string.isRequired,
};
